import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import compose from "ramda/src/compose"

import WrapperSkeleton from "components/WrapperSkeleton"
import AccessDeniedModal from "components/AccessDeniedModal"
import { getPermissions } from "services/state/permissions/action"
import { isPageAllowed } from "services/state/permissions/isPageAllowed"

const AccessControlProvider = ({
  path,
  permissions,
  getPermissions,
  history,
  children
}) => {
  const [checkedPath, setCheckedPath] = useState(null)

  useEffect(() => {
    setCheckedPath(null)
    getPermissions().then(() => setCheckedPath(path))
  }, [path])

  const isChecking = checkedPath !== path
  const allowed = isPageAllowed(path, permissions.data.pages)

  const handleRedirect = () => {
    history.push("/inicio")
  }

  return (
    <WrapperSkeleton path={path} isChildrenReady={!isChecking}>
      {allowed ? (
        children
      ) : (
        <AccessDeniedModal isOpen onRedirect={handleRedirect} />
      )}
    </WrapperSkeleton>
  )
}

AccessControlProvider.propTypes = {
  path: PropTypes.string,
  permissions: PropTypes.shape({
    data: PropTypes.shape({
      pages: PropTypes.array
    })
  }),
  getPermissions: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func
  }),
  children: PropTypes.node
}

const mapStateToProps = ({ permissions }) => ({ permissions })

const enhance = compose(
  withRouter,
  connect(mapStateToProps, { getPermissions })
)

export default enhance(AccessControlProvider)



// WEBPACK FOOTER //
// ./src/components/AccessControlProvider/index.js